<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="5">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.searchKey"
              :placeholder="'Search here...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="exportFile"
              v-if="allow('E')"
            >
              <b-icon-cloud-download></b-icon-cloud-download
              >{{ $l("btn_export") || "导出" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_department_name') || '部门名称'"
            >
              <el-input
                v-model="form.departmentName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_number_of_projects') || '创建项目数量'"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                size="small"
                :min="0"
                :step="1"
                v-model="form.prjQty"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item
              :label="this.$l('table_label_number_of_progress') || '进行中数量'"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                size="small"
                :min="0"
                :step="1"
                v-model="form.prjInProcessQty"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              :label="this.$l('table_label_number_of_completed_on_time') || '按时完成数量'"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                size="small"
                :min="0"
                :step="1"
                v-model="form.prjAcomplishedQty"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item
              :label="this.$l('table_label_number_of_completed_overtime') || '超时完成数量'"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                size="small"
                :min="0"
                :step="1"
                v-model="form.prjDelayQty"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              :label="this.$l('table_label_number_of_termination') || '终止取消数量'"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                size="small"
                :min="0"
                :step="1"
                v-model="form.prjTerminationQty"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  searchKey: "",
};

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    query() {
      this.$emit("submit", this.form);
    },
    onReset() {
      this.form = {
        ...initForm,
      };
      this.$emit("reset");
      this.query();
    },
    exportFile() {
      let url = "/digitalCenter/report/export/projectOverallList";
      let fileName = "项目整体情况分析";
      this.$api.globalExportData(url, this.form, fileName);
    },
    // 高级查询
    advquery() {
      this.form.searchKey = "";
      this.query();
      this.closeAdvqueryDialog();
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm };
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true;
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false;
    },
  },
  created() {
    this.onReset();
  },
  activated() {
    this.onReset();
  },
};
</script>
